import { compose } from 'recompose';
import FinanceInvoicing from './finance-invoicing.view';

export default compose(FinanceInvoicing);
